import { render } from "./Roster.vue?vue&type=template&id=53a1173b"
import script from "./Roster.vue?vue&type=script&lang=js"
export * from "./Roster.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "53a1173b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53a1173b', script)) {
    api.reload('53a1173b', script)
  }
  
  module.hot.accept("./Roster.vue?vue&type=template&id=53a1173b", () => {
    api.rerender('53a1173b', render)
  })

}

script.__file = "src/components/Roster.vue"

export default script